import { API } from 'aws-amplify'
import getUserById from '~header/api/getUserById'
import { createApi } from '~header/states/context'

export const amplifyGraphqlBaseQuery = async ({ query, variables }) => {
  try {
    const result = await API.graphql({
      query,
      variables
    })
    return { data: result.data }
  } catch (error) {
    return { error }
  }
}

const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: amplifyGraphqlBaseQuery,
  endpoints: (builder) => ({
    getUserById: builder.query({
      queryFn: async ({ byUserId }) => {
        try {
          const data = await getUserById(byUserId)
          return { data }
        } catch (error) {
          return { error }
        }
      }
    })
  })
})

export const { useGetUserByIdQuery } = userApi
export default userApi
